import type { FilterSection } from '@/types/filter'
import monthsFilterOption from "@/utils/constants/monthsFilterOption";
import pressReleaseCategoryFilterOptions from '@/utils/constants/pressReleaseCategoryFilterOptions';
import yearsFilterOption from "@/utils/constants/yearsFilterOption";

const FILTER_SECTIONS: FilterSection[] = [
  // {
  //   key: 'landingPage',
  //   label: 'Landing Page',
  //   type: 'boolean',
  // },
  // {
  //   key: 'pressRelease',
  //   label: 'Press Release',
  //   type: 'boolean',
  // },
  // {
  //   key: 'pressReleaseBanner',
  //   label: 'Press Release Banner',
  //   type: 'boolean',
  // },
  // {
  //   key: 'allowComment',
  //   label: 'Allow Comment',
  //   type: 'boolean',
  // },
  {
      key: 'pressReleaseCategory',
      label: 'Press Release Category',
      type: 'select',
      options: pressReleaseCategoryFilterOptions,
  },
  {
      key: 'year',
      label: 'Year',
      type: 'select',
      options: yearsFilterOption,
    },
    {
      key: 'month',
      label: 'Month',
      type: 'select',
      options: monthsFilterOption,
    },
]

export default FILTER_SECTIONS